module.exports = __webpack_public_path__ + "static/media/checklist.8979106f.png";